<template>
    <footer class="footer mt-auto yoyo-darkgray yoyo-whiteTextcolor">
        <p v-if="Object.keys(this.branch).length > 0" name="footer">
            Link Logistics - {{ branch.address }} - {{ branch.countryCode }}-{{ branch.zip }}
            {{ branch.city }} - Phone: {{ branch.phone }} E-mail: {{ branch.email3 }}
        </p>
    </footer>
</template>
<script>
  import { EventBus } from '../services/event-bus.js';
  import { EVENTS } from '../store/nameConstants';

  export default {
      props: {},
      components: {},
      data() {
          return {
              branch: {}
          };
      },

      created() {
          EventBus.$on(EVENTS.SET_USER_BRANCH, (senderData) => {
              this.branch = senderData;
          });
      }
  };
</script>
